import React from 'react';
import { AlertTriangle, TrendingUp, Shield, Activity } from 'lucide-react';
import { Risk, RiskMetrics as RiskMetricsType } from '../../types/risk';

interface RiskMetricsProps {
  metrics: RiskMetricsType;
}

export default function RiskMetrics({ metrics }: RiskMetricsProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      <div className="bg-white p-4 rounded-lg shadow-sm">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-sm font-medium text-gray-700">Total Risks</h3>
          <Activity className="w-5 h-5 text-blue-500" />
        </div>
        <p className="text-2xl font-bold text-gray-900">{metrics.total}</p>
        <div className="mt-2 flex items-center text-sm text-gray-500">
          <span>Across all categories</span>
        </div>
      </div>

      <div className="bg-white p-4 rounded-lg shadow-sm">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-sm font-medium text-gray-700">High Risk Items</h3>
          <AlertTriangle className="w-5 h-5 text-red-500" />
        </div>
        <p className="text-2xl font-bold text-gray-900">{metrics.high}</p>
        <div className="mt-2 flex items-center text-sm text-gray-500">
          <span>Need immediate attention</span>
        </div>
      </div>

      <div className="bg-white p-4 rounded-lg shadow-sm">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-sm font-medium text-gray-700">Mitigated</h3>
          <Shield className="w-5 h-5 text-green-500" />
        </div>
        <p className="text-2xl font-bold text-gray-900">{metrics.mitigated}</p>
        <div className="mt-2 flex items-center text-sm text-gray-500">
          <span>Successfully addressed</span>
        </div>
      </div>

      <div className="bg-white p-4 rounded-lg shadow-sm">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-sm font-medium text-gray-700">Risk Trend</h3>
          <TrendingUp className="w-5 h-5 text-orange-500" />
        </div>
        <p className="text-2xl font-bold text-gray-900">
          {((metrics.mitigated / metrics.total) * 100).toFixed(1)}%
        </p>
        <div className="mt-2 flex items-center text-sm text-gray-500">
          <span>Mitigation rate</span>
        </div>
      </div>

      <div className="col-span-full">
        <h4 className="text-sm font-medium text-gray-700 mb-4">Risk Distribution</h4>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {Object.entries(metrics.byCategory).map(([category, count]) => (
            <div key={category} className="bg-white p-4 rounded-lg shadow-sm">
              <div className="flex items-center justify-between mb-2">
                <h5 className="text-sm font-medium text-gray-700 capitalize">{category}</h5>
                <span className="text-sm text-gray-500">{count} risks</span>
              </div>
              <div className="w-full h-2 bg-gray-200 rounded-full">
                <div
                  className="h-2 bg-blue-600 rounded-full"
                  style={{ width: `${(count / metrics.total) * 100}%` }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}